import { useEffect, useState } from "react";
import { ScorecardLicenseExpiryModalResult } from "../../../../Component/Model/Dto/ScorecardLicenseExpiry/ScorecardLicenseExpiry";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Link, List, ListItem } from "@mui/material";
import { MDTypography } from "../../../../Component/Common/Components/MDTypography";
import colors from "../../../../assets/theme/base/colors";
import { getDateAsString } from "../../../../Helpers/DateFormatter";

const { warning, error, primary } = colors;

interface IProps {
    username: string;
    licenseResult: ScorecardLicenseExpiryModalResult;
    open: boolean;
    close: () => void;
}

export const ScorecardLicenseExpiryModal = (props: IProps) => {

    const [titleText, setTitleText] = useState('');
    const [colour, setColour] = useState('');
    const [paragraph, setParagraph] = useState('');
    const [imageSrc, setImageSrc] = useState('');

    const getModalDetails = () => {
        const titleText = props.licenseResult.daysRemaining < 0
            ? `Your scorecard license expired on ${(getDateAsString(props.licenseResult.expiryDate))}`
            : `Your scorecard license expires ${props.licenseResult.daysRemaining === 0 ? 'today' : 'on'} ${getDateAsString(props.licenseResult.expiryDate)}`;

        const paragraph = props.licenseResult.daysRemaining < 0
            ? `Your current license expired on ${getDateAsString(props.licenseResult.expiryDate)}. Please complete your renewal to restore full access to the software and all services as per your current SLA.`
            : `Your current license expires ${props.licenseResult.daysRemaining === 0 ? 'today' : 'on'} ${getDateAsString(props.licenseResult.expiryDate)}. Completion of your renewal on or 
        before the license expiry date ensures uninterrupted access to the software, and all services as per your current SLA.`;

        const colour = props.licenseResult.daysRemaining < 31
            ? error.main
            : props.licenseResult.daysRemaining < 61
                ? warning.main
                : primary.main;

        const imageSrc = props.licenseResult.daysRemaining < 31
            ? 'CalendarError.svg'
            : props.licenseResult.daysRemaining < 61
                ? 'CalendarWarning.svg'
                : 'CalendarPrimary.svg';

        setTitleText(titleText);
        setColour(colour);
        setParagraph(paragraph);
        setImageSrc(imageSrc)
    }

    const renderAdminUsers = () => (
        <List sx={{ paddingLeft: '20px', margin: 0, listStyleType: 'disc' }}>
            {props.licenseResult.adminUsers.map((admin, index) => (
                <ListItem key={index} sx={{ display: 'list-item', paddingLeft: 0 }}>
                    <MDTypography variant="body">
                        {admin.name} - <Link href={`mailto:${admin.email}`} underline="always" color={primary.main}>{admin.email}</Link>
                    </MDTypography>
                </ListItem>
            ))}
        </List>
    );

    useEffect(() => {
        getModalDetails();
    }, []);

    return (
        <>
            <Dialog
                open={props.open}
                onClose={() => { }}
                aria-labelledby="information-dialog-title"
                maxWidth='md'
            >
                <DialogTitle color={colour} paddingLeft={2} paddingTop={1}>
                    {titleText}
                </DialogTitle>

                <DialogContent sx={{ padding: '20px' }}>
                    <Grid container spacing={2} paddingLeft={2} paddingRight={2}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                            <img
                                src={`${process.env.PUBLIC_URL}/img/${imageSrc}`}
                                style={{ maxWidth: '50%', marginTop: '10px' }}
                            />
                        </div>

                        <Grid item xs={12}>
                            <MDTypography variant='body'>
                                Dear {props.username},
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12}>
                            <MDTypography variant='body'>
                                {paragraph}
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12} paddingY={2}>
                            <MDTypography variant="body">
                                If you are not the contact responsible for the BEE123 renewal, kindly engage your BEE123 Admin Users:
                            </MDTypography>
                            {renderAdminUsers()}
                        </Grid>

                        <Grid item xs={12}>
                            <MDTypography variant='body'>
                                For any additional information, please feel free to contact our Strategic Relationship Management team -
                                <Link href={`mailto:srm@bee123.co.za`} underline="always" color={primary.main} style={{ marginLeft: 8 }}>srm@bee123.co.za</Link>
                            </MDTypography>
                            <MDTypography variant='body'>
                                <br />
                                Invoice and Statement Requests - <Link href={`mailto:renewals@bee123.co.za`} underline="always" color={primary.main}>renewals@bee123.co.za</Link>
                                <br />
                                Or call us on: 0861 233 123
                            </MDTypography>
                        </Grid>

                        <Grid item xs={12}>
                            <MDTypography variant='body'>
                                Kind regards,<br />BEE123
                            </MDTypography>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button
                        variant='contained'
                        onClick={props.close}
                        sx={{
                            margin: '10px',
                            backgroundColor: colour,
                            '&:hover': { backgroundColor: colour }
                        }}
                    >
                        Got it!
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}